import React from 'react';
import { TouchableWithoutFeedback, TouchableWithoutFeedbackProps } from 'react-native';
import StateLink from '../../StateLink';

type StateSpec = {
  to: string;
  params?: { [key: string]: string | number };
};

type StateLinkProps = {
  clickTracking?: string | {
    name: string;
    params: { [key: string]: string | number };
  };
  target?: string;
} & (
  { href: string } | StateSpec
);

export type TouchablePropsWithClick = {
  onClick: (e?: any, value?: any) => void;
  onPress?: (e?: any) => void;
  stateLinkProps?: StateLinkProps;
  children?: React.ReactNode;
  testID?: string;
};

export type TouchablePropsWithPress = {
  onClick?: (e?: any) => void;
  onPress: (e?: any) => void;
  stateLinkProps?: StateLinkProps;
  children?: React.ReactNode;
  testID?: string;
};
export type TouchableProps = (TouchablePropsWithClick | TouchablePropsWithPress)
& TouchableWithoutFeedbackProps;

const RetypedTouchableWithoutFeedback = (
  TouchableWithoutFeedback as unknown as React.FC<TouchableProps>
);

const Touchable = ({
  onClick,
  stateLinkProps,
  children,
  testID,
  ...props
}: TouchableProps) => {
  if (stateLinkProps) {
    return (
      <StateLink
        onClick={onClick}
        testID={testID}
        {...stateLinkProps}
      >
        {children}
      </StateLink>
    );
  }
  return (
    <RetypedTouchableWithoutFeedback
      onClick={onClick}
      testID={testID}
      {...props}
    >
      {children}
    </RetypedTouchableWithoutFeedback>
  );
};

export default Touchable;
